var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-select',_vm._g(_vm._b({staticClass:"w-full",attrs:{"options":_vm.options,"labelKey":"name","label":_vm.$tc('shipping_method', 1),"valueKey":"slug","clearable":"","remote":"","filterable":"","remote-method":_vm.fetchOptions,"loading":_vm.loading,"valueIsObject":_vm.valueIsObject}},'core-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }